/*
 * @Author:
 * @LastEditTime: 2022-06-15 15:22:22
 * @Description:
 */
import qs from 'qs'
import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinTaskType = {
  async apiTaskType(arg = { method: '', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'update':
        ;[err, res] = await To(
          wizStandardInstance.put(`/api/std/TaskInfo/${arg.params.id}`, arg.params)
        )
        break
      case 'edit':
        ;[err, res] = await To(
          wizStandardInstance.put(`/api/std/TaskInfo/${arg.params.id}`, arg.params)
        )
        break
      case 'create':
        ;[err, res] = await To(wizStandardInstance.post('/api/std/TaskInfo', arg.params))
        break
      case 'batch':
        ;[err, res] = await To(wizStandardInstance.put('/api/std/TaskInfo/many', arg.params))
        break
      default:
        const listObj = {
          Name: ' ',
          SkipCount: 1,
          MaxResultCount: 10,
          Sorting: ' ',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/std/TaskInfo?${qs.stringify(listObj)}`))
        )
    }
    return Callback.globalCB(err, res)
  },
}

export default {
  methods: ApiMixinTaskType,
}
